<template>
  <div class="carouselDiv" :style="editForm.style">
    <el-carousel
      :direction="editForm.direction"
      :autoplay="editForm.autoplay"
      :indicator-position="editForm.indicatorPosition"
      :type="editForm.type"
    >
      <el-carousel-item v-for="item in 3" :key="item">
        <h2 class="medium">{{ item }}</h2>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: { editForm: Object },
};
</script>
<style scoped>
.el-carousel {
  height: 100%;
}
.carouselDiv >>> .el-carousel__container {
  height: 100%;
}
.el-carousel__item {
  display: flex;
  justify-items: center;
  align-items: center;
}
.el-carousel__item h2 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  margin: auto;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineTemplate/template/carousel.vue